import React from 'react';
import FadeIn from './ui/FadeIn';

export default function Pricing() {
  return (
    <section className="py-24 bg-white">
      <div className="container mx-auto px-6 md:px-12 max-w-4xl">
        <FadeIn className="text-center mb-16">
          <h2 className="font-heading text-4xl font-bold mb-4">Clean, Honest Pricing</h2>
          <p className="text-gray-500">No hidden fees. Just straightforward wholesale pricing.</p>
        </FadeIn>

        <FadeIn delay={0.1} className="bg-warmWhite rounded-3xl p-8 md:p-12 shadow-sm border border-gray-100">
          <div className="flex flex-col md:flex-row justify-between items-center border-b border-gray-200 pb-8 mb-8">
            <div>
              <h3 className="font-heading text-2xl font-semibold mb-2">Standard Vase</h3>
              <p className="text-gray-500">10" tall × 3.5" wide</p>
            </div>
            <div className="text-right mt-4 md:mt-0">
              <span className="text-5xl font-heading font-bold text-charcoal">$20</span>
              <span className="text-gray-500 ml-2">/ per vase</span>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div>
              <h4 className="font-semibold text-charcoal mb-4 uppercase tracking-wider text-sm">Order Details</h4>
              <ul className="space-y-3 text-gray-600 font-light">
                <li className="flex items-center"><span className="w-1.5 h-1.5 bg-blush rounded-full mr-3"></span> Minimum order: 4 vases</li>
                <li className="flex items-center"><span className="w-1.5 h-1.5 bg-blush rounded-full mr-3"></span> Ships in boxes of 4</li>
              </ul>
            </div>
            
            <div>
              <h4 className="font-semibold text-charcoal mb-4 uppercase tracking-wider text-sm">Shipping & Delivery</h4>
              <ul className="space-y-3 text-gray-600 font-light text-sm">
                <li className="flex justify-between border-b border-gray-200 pb-2">
                  <span>Arizona (Flat rate per box)</span>
                  <span className="font-medium">$18</span>
                </li>
                <li className="flex justify-between border-b border-gray-200 pb-2">
                  <span>Southwest (Flat rate per box)</span>
                  <span className="font-medium">$24</span>
                </li>
                <li className="flex justify-between border-b border-gray-200 pb-2">
                  <span>National (Flat rate per box)</span>
                  <span className="font-medium">$30</span>
                </li>
                <li className="flex justify-between text-sage pt-1">
                  <span>West Valley Local (8+ vases)</span>
                  <span className="font-medium">FREE</span>
                </li>
                <li className="flex justify-between text-xs text-gray-400">
                  <span>West Valley Local (&lt;8 vases)</span>
                  <span>$15</span>
                </li>
              </ul>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>
  );
}